import { UserAccountsResponse } from '../../../models/user/accounts/UserAccountsResponse';
import { client } from '../../apiClient';

const USER_ACCOUNTS_ENDPOINT = '/user/accounts';

export const getUserAccounts = async (): Promise<UserAccountsResponse[]> => {
  return client(true, true)
    .get<UserAccountsResponse[]>(`${USER_ACCOUNTS_ENDPOINT}/`)
    .then((response) => response.data);
};
